angular.module('unergie.main')
.factory('EstimateTimetableService', ($state, $uibModal, TimetableGeneration, DataAccess, ErrorCatcher) => {
    const openModal = function (draft, callBack) {
        const modalInstance = $uibModal.open({
            animation: true,
            size: 'lg',
            controller: 'estimateTimetableModalCtrl',
            templateUrl: '/states/estimateTimetableModal/estimateTimetableModal.html',
            resolve: {
                timetables() {
                    return TimetableGeneration.draftTimetableV2({ idContract: draft.id }, {}).$promise
                    .catch((error) => {
                        ErrorCatcher(error)
                        throw error })
                },
            },
        })
        return modalInstance.result.finally((result) => {
            if (callBack) {
                return callBack(result)
            }
        })
    }

    return {
        openModal,
    }
})
